import { Color, Spacing } from '@persona-id/design-tokens';
import { Link } from 'react-router-dom-v5-compat';
import styled from 'styled-components';

import InactiveEnvironmentBanner from 'dashboard/components/InactiveEnvironmentBanner';
import { Container, Section } from 'dashboard/layouts/IndexViewLayoutV2';
import Card from 'design-system/components/Card';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label, Paragraph } from 'design-system/components/Text';
import { TransitionDuration } from 'design-system/variables/transitions';
import DeveloperDocsImage from 'images/dashboard/onboarding/hero-card-developer-docs.svg';
import IntegrationsImage from 'images/dashboard/onboarding/hero-card-integrations.svg';

const DashboardNoEnvironmentHomeView = () => {
  return (
    <>
      <InactiveEnvironmentBanner />
      <Container>
        <Section>
          <Card>
            <Card.Body>
              <Heading size='sm'>Discover more from Persona</Heading>
              <Spacer height={1} />
              <DiscoverCardsWrapper>
                <DiscoverCard>
                  <Link to='/dashboard/getting-started'>
                    <DiscoverCardImage>
                      <IntegrationsImage />
                    </DiscoverCardImage>
                    <DiscoverCardBody>
                      <Label size='lg' weight='bold'>
                        View integration guides
                      </Label>
                      <Spacer height={1} />
                      <Paragraph>Select the right method with step-by-step guides.</Paragraph>
                    </DiscoverCardBody>
                  </Link>
                </DiscoverCard>
                <DiscoverCard>
                  <a href='https://docs.withpersona.com/docs' target='_blank' rel='noreferrer'>
                    <DiscoverCardImage>
                      <DeveloperDocsImage />
                    </DiscoverCardImage>
                    <DiscoverCardBody>
                      <Label size='lg' weight='bold'>
                        View developer documentation
                      </Label>
                      <Spacer height={1} />
                      <Paragraph>
                        Reference comprehensive information for integrating with Persona and our API
                        endpoints.
                      </Paragraph>
                    </DiscoverCardBody>
                  </a>
                </DiscoverCard>
              </DiscoverCardsWrapper>
            </Card.Body>
          </Card>
        </Section>
      </Container>
    </>
  );
};

const DiscoverCardsWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  column-gap: ${Spacing[4]};

  > * {
    flex: 1;
    margin-bottom: ${Spacing[4]};
  }
`;

const DiscoverCard = styled('button')`
  display: flex;
  flex-direction: column;
  min-width: 200px;
  max-width: 300px;
  border: 1px solid ${({ theme }) => theme.color.border.primary};
  border-radius: ${({ theme }) => theme.card.borderRadius};
  cursor: pointer;
  transition: ${TransitionDuration.Fast};
  background-color: ${({ theme }) => theme.color.primary.white};
  text-align: left;

  :hover {
    transform: scale(1.02);
  }
`;

const DiscoverCardImage = styled('div')`
  width: 100%;
  background-color: ${Color.CorePurple100};

  > svg {
    width: 100%;
    border-radius: ${({ theme }) => theme.card.borderRadius}
      ${({ theme }) => theme.card.borderRadius} 0px 0px;
  }
`;

const DiscoverCardBody = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: ${Spacing[4]};
`;

export default DashboardNoEnvironmentHomeView;
